import Image from 'next/image';
import type { JSX } from 'react';

// Solid
import Bars from './svgs/solid/bars.svg';
import CartShopping from './svgs/solid/cart-shopping.svg';
import ChevronDown from './svgs/solid/chevron-down.svg';
import ChevronUp from './svgs/solid/chevron-up.svg';
import CircleNotch from './svgs/solid/circle-notch.svg';
import CirclePlus from './svgs/solid/circle-plus.svg';
import CommentLines from './svgs/solid/comment-lines.svg';
import SolidHeart from './svgs/solid/heart.svg';
import Lock from './svgs/solid/lock.svg';
import Minus from './svgs/solid/minus.svg';
import Plus from './svgs/solid/plus.svg';
import Ruler from './svgs/solid/ruler.svg';
import HalfStar from './svgs/solid/star-half.svg';
import CircleXMark from './svgs/solid/circle-xmark.svg';
import FullStar from './svgs/solid/star.svg';
import User from './svgs/solid/user.svg';
import Xmark from './svgs/solid/xmark.svg';
import Box from './svgs/solid/box.svg';
import CircleStar from './svgs/solid/circle-star.svg';
import Comments from './svgs/solid/comments.svg';
import LocationDot from './svgs/solid/location-dot.svg';

// Solid Directions
import AngleDown from './svgs/solid/angle-down.svg';
import AngleLeft from './svgs/solid/angle-left.svg';
import AngleRight from './svgs/solid/angle-right.svg';
import AngleUp from './svgs/solid/angle-up.svg';
import ArrowDown from './svgs/solid/arrow-down.svg';
import ArrowLeft from './svgs/solid/arrow-left.svg';
import ArrowRightFromBracket from './svgs/solid/arrow-right-from-bracket.svg';
import ArrowRight from './svgs/solid/arrow-right.svg';
import ArrowUp from './svgs/solid/arrow-up.svg';
import CaretDown from './svgs/solid/caret-down.svg';
import CaretLeft from './svgs/solid/caret-left.svg';
import CaretRight from './svgs/solid/caret-right.svg';
import CaretUp from './svgs/solid/caret-up.svg';
import MapMarker from './svgs/solid/map-marker.svg';
import RightLeft from './svgs/solid/right-left.svg';
import SortUp from './svgs/solid/sort-up.svg';

// Regular
import ExclamationCircle from './svgs/regular/circle-exclamation.svg';
import QuestionCircle from './svgs/regular/circle-question.svg';
import Heart from './svgs/regular/heart.svg';
import EmptyStar from './svgs/regular/star.svg';
import ThumbsDown from './svgs/regular/thumbs-down.svg';
import ThumbsUp from './svgs/regular/thumbs-up.svg';
import TrashCan from './svgs/regular/trash-can.svg';
import UserOutline from './svgs/regular/user.svg';

import BarChart from './svgs/regular/bar-chart.svg';
import BoundingBox from './svgs/regular/bounding-box.svg';
import Briefcase from './svgs/regular/briefcase.svg';
import ChatboxEllipses from './svgs/regular/chatbox-ellipses.svg';
import Expand from './svgs/regular/expand.svg';
import FileTray from './svgs/regular/file-tray.svg';
import Megaphone from './svgs/regular/megaphone.svg';
import Paper from './svgs/regular/paper.svg';
import PlayRegular from './svgs/regular/play.svg';
import Reload from './svgs/regular/reload.svg';
import Sliders from './svgs/regular/sliders.svg';
import Storefront from './svgs/regular/storefront.svg';
import Terminal from './svgs/regular/terminal.svg';
import CircleInfo from './svgs/regular/circle-info-regular.svg';
import TimerRegular from './svgs/regular/timer.svg';
import Clock from './svgs/regular/clock.svg';

// Regular Sharp
import EmptyStarSharp from './svgs/regular/sharp/star.svg';

// Solid
import EyeSlash from './svgs/solid/eye-slash.svg';
import Eye from './svgs/solid/eye.svg';
import Loader from './svgs/solid/loader.svg';
import LockKeyhole from './svgs/solid/lock-keyhole.svg';
import MagnifyingGlassMinus from './svgs/solid/magnifying-glass-minus.svg';
import MagnifyingGlassPlus from './svgs/solid/magnifying-glass-plus.svg';
import MagnifyingGlass from './svgs/solid/magnifying-glass.svg';

// Sharp Solid
import CircleInfoSolid from './svgs/solid/circle-info-solid.svg';

import Play from './svgs/sharp-solid/play.svg';
import Pause from './svgs/sharp-solid/pause.svg';
import StarSharp from './svgs/sharp-solid/star.svg';
import HalfStarSharp from './svgs/sharp-solid/half-star.svg';

// Light
import AngleDownLight from './svgs/light/angle-down.svg';
import AngleLeftLight from './svgs/light/angle-left.svg';
import AngleRightLight from './svgs/light/angle-right.svg';
import AngleUpLight from './svgs/light/angle-up.svg';
import ArrowDownLight from './svgs/light/arrow-down.svg';
import ArrowLeftLight from './svgs/light/arrow-left.svg';
import ArrowRightLight from './svgs/light/arrow-right.svg';
import ArrowUpLight from './svgs/light/arrow-up.svg';
import BagShoppingLight from './svgs/light/bag-shopping.svg';
import BarsLight from './svgs/light/bars.svg';
import ChevronDownLight from './svgs/light/chevron-down.svg';
import ChevronUpLight from './svgs/light/chevron-up.svg';
import CircleChevronLeftLight from './svgs/light/circle-chevron-left.svg';
import CircleChevronRightLight from './svgs/light/circle-chevron-right.svg';
import CircleNotchLight from './svgs/light/circle-notch.svg';
import ExpandLight from './svgs/light/expand.svg';
import HelpChatLight from './svgs/light/help-chat.svg';
import SearchLight from './svgs/light/magnifying-glass.svg';
import PlusLight from './svgs/light/plus.svg';
import StorefrontLight from './svgs/light/storefront-light.svg';
import ThumbsDownLight from './svgs/light/thumbs-down.svg';
import ThumbsUpLight from './svgs/light/thumbs-up.svg';
import TruckLight from './svgs/light/truck.svg';
import UserLight from './svgs/light/user.svg';
import XmarkLight from './svgs/light/xmark.svg';
import MinusLight from './svgs/light/minus.svg';
import CircleInfoLight from './svgs/light/circle-info-light.svg';
import GlobeLight from './svgs/light/globe.svg';

// Brands
import FacebookF from './svgs/brands/facebook-f.svg';
import Instagram from './svgs/brands/instagram.svg';
import PinterestP from './svgs/brands/pinterest-p.svg';
import Strava from './svgs/brands/strava.svg';
import TikTok from './svgs/brands/tiktok.svg';
import Twitter from './svgs/brands/twitter.svg';
import Youtube from './svgs/brands/youtube.svg';

// Flags
import ADFlag from './svgs/flags/ad.svg';
import AEFlag from './svgs/flags/ae.svg';
import ALFlag from './svgs/flags/al.svg';
import ATFlag from './svgs/flags/at.svg';
import AUFlag from './svgs/flags/au.svg';
import BAFlag from './svgs/flags/ba.svg';
import BEFlag from './svgs/flags/be.svg';
import BGFlag from './svgs/flags/bg.svg';
import BRFlag from './svgs/flags/br.svg';
import CAFlag from './svgs/flags/ca.svg';
import CHFlag from './svgs/flags/ch.svg';
import CLFlag from './svgs/flags/cl.svg';
import CNFlag from './svgs/flags/cn.svg';
import COFlag from './svgs/flags/co.svg';
import CYFlag from './svgs/flags/cy.svg';
import CZFlag from './svgs/flags/cz.svg';
import DEFlag from './svgs/flags/de.svg';
import DKFlag from './svgs/flags/dk.svg';
import DZFlag from './svgs/flags/dz.svg';
import EEFlag from './svgs/flags/ee.svg';
import ESFlag from './svgs/flags/es.svg';
import FIFlag from './svgs/flags/fi.svg';
import FRFlag from './svgs/flags/fr.svg';
import GBFlag from './svgs/flags/gb.svg';
import GRFlag from './svgs/flags/gr.svg';
import HKFlag from './svgs/flags/hk.svg';
import HRFlag from './svgs/flags/hr.svg';
import HUFlag from './svgs/flags/hu.svg';
import IDFlag from './svgs/flags/id.svg';
import IEFlag from './svgs/flags/ie.svg';
import ILFlag from './svgs/flags/il.svg';
import ISFlag from './svgs/flags/is.svg';
import ITFlag from './svgs/flags/it.svg';
import JEFlag from './svgs/flags/je.svg';
import JPFlag from './svgs/flags/jp.svg';
import KRFlag from './svgs/flags/kr.svg';
import KZFlag from './svgs/flags/kz.svg';
import LTFlag from './svgs/flags/lt.svg';
import LUFlag from './svgs/flags/lu.svg';
import LVFlag from './svgs/flags/lv.svg';
import MAFlag from './svgs/flags/ma.svg';
import MCFlag from './svgs/flags/mc.svg';
import MDFlag from './svgs/flags/md.svg';
import MEFlag from './svgs/flags/me.svg';
import MKFlag from './svgs/flags/mk.svg';
import MTFlag from './svgs/flags/mt.svg';
import NLFlag from './svgs/flags/nl.svg';
import NOFlag from './svgs/flags/no.svg';
import NZFlag from './svgs/flags/nz.svg';
import PHFlag from './svgs/flags/ph.svg';
import PLFlag from './svgs/flags/pl.svg';
import PTFlag from './svgs/flags/pt.svg';
import REFlag from './svgs/flags/re.svg';
import ROFlag from './svgs/flags/ro.svg';
import RSFlag from './svgs/flags/rs.svg';
import RUFlag from './svgs/flags/ru.svg';
import SEFlag from './svgs/flags/se.svg';
import SGFlag from './svgs/flags/sg.svg';
import SIFlag from './svgs/flags/si.svg';
import SKFlag from './svgs/flags/sk.svg';
import TNFlag from './svgs/flags/tn.svg';
import TRFlag from './svgs/flags/tr.svg';
import TWFlag from './svgs/flags/tw.svg';
import UAFlag from './svgs/flags/ua.svg';
import USFlag from './svgs/flags/us.svg';
import ZAFlag from './svgs/flags/za.svg';

import blog from './pngs/blog.png';
import deckersWhite from './pngs/deckers-white.png';
import deckersBlack from './pngs/deckers-black.png';

/**
 * A list of all available icons and their access name and the string used
 * to get the actual icon.
 */
export enum IconTypes {
  // Core
  Close = 'close',
  CloseLight = 'closeLight',
  Bars = 'bars',
  BarsLight = 'barsLight',
  Search = 'search',
  SearchLight = 'searchLight',
  User = 'user',
  UserLight = 'userLight',
  UserOutline = 'userOutline',
  Ruler = 'ruler',
  Minus = 'minus',
  MinusLight = 'minusLight',
  CirclePlus = 'circlePlus',
  Plus = 'plus',
  ChevronUp = 'chevronUp',
  ChevronUpLight = 'chevronUpLight',
  ChevronDown = 'chevronDown',
  ChevronDownLight = 'chevronDownLight',
  Cart = 'cart',
  BagLight = 'bagLight',
  Heart = 'heart',
  HeartSolid = 'heartSolid',
  CircleNotch = 'circleNotch',
  CircleNotchLight = 'circleNotchLight',
  CircleChevronRightLight = 'circleChevronRightLight',
  CircleChevronLeftLight = 'circleChevronLeftLight',
  EmptyStar = 'emptyStar',
  HalfStar = 'halfStar',
  FullStar = 'fullStar',
  FullStarSharp = 'fullStarSharp',
  EmptyStarSharp = 'emptyStarSharp',
  HalfStarSharp = 'halfStarSharp',
  FullScreen = 'fullScreen',
  FullScreenLight = 'fullScreenLight',
  Globe = 'globeLight',
  Trash = 'trash',
  Timer = 'timer',
  Comment = 'comment',
  Lock = 'lock',
  Alert = 'alert',
  Like = 'like',
  LikeLight = 'likeLight',
  Dislike = 'dislike',
  DislikeLight = 'dislikeLight',
  MagnifyingGlass = 'magnifyingGlass',
  MagnifyingGlassPlus = 'magnifyingGlassPlus',
  MagnifyingGlassMinus = 'magnifyingGlassMinus',
  Eye = 'eye',
  EyeSlash = 'eyeSlash',
  LockKeyHole = 'lockKeyhole',
  PlusLight = 'plusLight',
  Sliders = 'sliders',
  CircleXMark = 'circleXMark',
  CircleInfo = 'circleInfo',
  CircleInfoLight = 'circleInfoLight',
  CircleInfoSolid = 'circleInfoSolid',

  // Deckers
  DeckersWhite = 'deckersWhite',
  DeckersBlack = 'deckersBlack',

  // Directions
  ArrowUp = 'arrowUp',
  ArrowDown = 'arrowDown',
  ArrowLeft = 'arrowLeft',
  ArrowRight = 'arrowRight',
  ArrowRightFromBracket = 'arrowRightFromBracket',
  ArrowDownLight = 'arrowDownLight',
  ArrowLeftLight = 'arrowLeftLight',
  ArrowRightLight = 'arrowRightLight',
  ArrowUpLight = 'arrowUpLight',
  AngleRight = 'angleRight',
  AngleLeft = 'angleLeft',
  AngleUp = 'angleUp',
  AngleDown = 'angleDown',
  AngleRightLight = 'angleRightLight',
  AngleLeftLight = 'angleLeftLight',
  AngleUpLight = 'angleUpLight',
  AngleDownLight = 'angleDownLight',
  CaretUp = 'caretUp',
  CaretRight = 'caretRight',
  CaretDown = 'caretDown',
  CaretLeft = 'caretLeft',
  Pause = 'pause',
  Play = 'play',
  PlayRegular = 'playRegular',
  Loader = 'loader',
  RightLeft = 'rightLeft',
  MapMarker = 'mapMarker',
  SortUp = 'sortUp',

  // Social
  Instagram = 'instagram',
  Twitter = 'twitter',
  YouTube = 'youtube',
  Pinterest = 'pinterest',
  Facebook = 'facebook',
  QuestionCircle = 'questionCircle',
  Blog = 'blog',
  Strava = 'strava',
  TikTok = 'tiktok',

  // Flags
  ADFlag = 'adFlag',
  AEFlag = 'aeFlag',
  ALFlag = 'alFlag',
  ATFlag = 'atFlag',
  AUFlag = 'auFlag',
  BAFlag = 'baFlag',
  BEFlag = 'beFlag',
  BGFlag = 'bgFlag',
  BRFlag = 'brFlag',
  CAFlag = 'caFlag',
  CHFlag = 'chFlag',
  CLFlag = 'clFlag',
  CNFlag = 'cnFlag',
  COFlag = 'coFlag',
  CYFlag = 'cyFlag',
  CZFlag = 'czFlag',
  DEFlag = 'deFlag',
  DKFlag = 'dkFlag',
  DZFlag = 'dzFlag',
  EEFlag = 'eeFlag',
  ESFlag = 'esFlag',
  FIFlag = 'fiFlag',
  FRFlag = 'frFlag',
  GBFlag = 'gbFlag',
  GRFlag = 'grFlag',
  HKFlag = 'hkFlag',
  HRFlag = 'hrFlag',
  HUFlag = 'huFlag',
  IDFlag = 'idFlag',
  IEFlag = 'ieFlag',
  ILFlag = 'ilFlag',
  ISFlag = 'isFlag',
  ITFlag = 'itFlag',
  JEFlag = 'jeFlag',
  JPFlag = 'jpFlag',
  KRFlag = 'krFlag',
  KZFlag = 'kzFlag',
  LTFlag = 'ltFlag',
  LUFlag = 'luFlag',
  LVFlag = 'lvFlag',
  MAFlag = 'maFlag',
  MCFlag = 'mcFlag',
  MDFlag = 'mdFlag',
  MEFlag = 'meFlag',
  MKFlag = 'mkFlag',
  MTFlag = 'mtFlag',
  NLFlag = 'nlFlag',
  NOFlag = 'noFlag',
  NZFlag = 'nzFlag',
  PHFlag = 'phFlag',
  PLFlag = 'plFlag',
  PTFlag = 'ptFlag',
  REFlag = 'reFlag',
  ROFlag = 'roFlag',
  RSFlag = 'rsFlag',
  RUFlag = 'ruFlag',
  SEFlag = 'seFlag',
  SGFlag = 'sgFlag',
  SIFlag = 'siFlag',
  SKFlag = 'skFlag',
  TNFlag = 'tnFlag',
  TRFlag = 'trFlag',
  TWFlag = 'twFlag',
  UAFlag = 'uaFlag',
  USFlag = 'usFlag',
  ZAFlag = 'zaFlag',

  // Business
  BarChart = 'barChart',
  Briefcase = 'briefcase',
  ChatboxEllipses = 'chatboxEllipses',
  Megaphone = 'megaphone',
  Paper = 'paper',
  Reload = 'reload',
  Terminal = 'terminal',
  Storefront = 'storefront',
  StorefrontLight = 'storefrontLight',
  TruckLight = 'truckLight',
  HelpChatLight = 'helpChatLight',
  FileTray = 'fileTray',
  BoundingBox = 'boundingBox',
  Box = 'box',
  CircleStar = 'circleStar',
  Comments = 'comments',
  LocationDot = 'locationDot',
  Clock = 'clock'
}

/**
 * Object used to turn the icon list into the specific icon imports.
 */
export const icons: Record<IconTypes, JSX.Element> = {
  // Core
  close: (() => <Xmark />)(),
  closeLight: (() => <XmarkLight />)(),
  bars: (() => <Bars />)(),
  barsLight: (() => <BarsLight />)(),
  search: (() => <SearchLight />)(),
  searchLight: (() => <SearchLight />)(),
  user: (() => <User />)(),
  userLight: (() => <UserLight />)(),
  userOutline: (() => <UserOutline />)(),
  ruler: (() => <Ruler />)(),
  minus: (() => <Minus />)(),
  minusLight: (() => <MinusLight />)(),
  plus: (() => <Plus />)(),
  circlePlus: (() => <CirclePlus />)(),
  circleChevronLeftLight: (() => <CircleChevronLeftLight />)(),
  circleChevronRightLight: (() => <CircleChevronRightLight />)(),
  chevronUp: (() => <ChevronUp />)(),
  chevronUpLight: (() => <ChevronUpLight />)(),
  chevronDown: (() => <ChevronDown />)(),
  chevronDownLight: (() => <ChevronDownLight />)(),
  cart: (() => <CartShopping />)(),
  bagLight: (() => <BagShoppingLight />)(),
  heartSolid: (() => <SolidHeart />)(),
  heart: (() => <Heart />)(),
  circleNotch: (() => <CircleNotch />)(),
  circleNotchLight: (() => <CircleNotchLight />)(),
  lock: (() => <Lock />)(),
  emptyStar: (() => <EmptyStar />)(),
  halfStar: (() => <HalfStar />)(),
  fullStar: (() => <FullStar />)(),
  fullScreen: (() => <Expand />)(),
  fullStarSharp: (() => <StarSharp />)(),
  emptyStarSharp: (() => <EmptyStarSharp />)(),
  halfStarSharp: (() => <HalfStarSharp />)(),
  fullScreenLight: (() => <ExpandLight />)(),
  globeLight: (() => <GlobeLight />)(),
  trash: (() => <TrashCan />)(),
  alert: (() => <ExclamationCircle />)(),
  plusLight: (() => <PlusLight />)(),
  sliders: (() => <Sliders />)(),
  circleXMark: (() => <CircleXMark />)(),
  circleInfo: (() => <CircleInfo />)(),
  circleInfoLight: (() => <CircleInfoLight />)(),
  circleInfoSolid: (() => <CircleInfoSolid />)(),
  timer: (() => <TimerRegular />)(),
  clock: (() => <Clock />)(),
  comment: (() => <CommentLines />)(),
  play: (() => <Play />)(),
  playRegular: (() => <PlayRegular />)(),
  pause: (() => <Pause />)(),
  loader: (() => <Loader />)(),
  like: (() => <ThumbsUp />)(),
  likeLight: (() => <ThumbsUpLight />)(),
  dislike: (() => <ThumbsDown />)(),
  dislikeLight: (() => <ThumbsDownLight />)(),
  magnifyingGlass: (() => <MagnifyingGlass />)(),
  magnifyingGlassPlus: (() => <MagnifyingGlassPlus />)(),
  magnifyingGlassMinus: (() => <MagnifyingGlassMinus />)(),
  eye: (() => <Eye />)(),
  eyeSlash: (() => <EyeSlash />)(),
  lockKeyhole: (() => <LockKeyhole />)(),

  // Direction
  arrowUp: (() => <ArrowUp />)(),
  arrowRight: (() => <ArrowRight />)(),
  arrowRightFromBracket: (() => <ArrowRightFromBracket />)(),
  arrowDownLight: (() => <ArrowDownLight />)(),
  arrowLeftLight: (() => <ArrowLeftLight />)(),
  arrowRightLight: (() => <ArrowRightLight />)(),
  arrowUpLight: (() => <ArrowUpLight />)(),
  arrowDown: (() => <ArrowDown />)(),
  arrowLeft: (() => <ArrowLeft />)(),
  angleRight: (() => <AngleRight />)(),
  angleLeft: (() => <AngleLeft />)(),
  angleUp: (() => <AngleUp />)(),
  angleDown: (() => <AngleDown />)(),
  angleRightLight: (() => <AngleRightLight />)(),
  angleLeftLight: (() => <AngleLeftLight />)(),
  angleUpLight: (() => <AngleUpLight />)(),
  angleDownLight: (() => <AngleDownLight />)(),
  caretUp: (() => <CaretUp />)(),
  caretRight: (() => <CaretRight />)(),
  caretDown: (() => <CaretDown />)(),
  caretLeft: (() => <CaretLeft />)(),
  rightLeft: (() => <RightLeft />)(),
  mapMarker: (() => <MapMarker />)(),
  sortUp: (() => <SortUp />)(),

  // Socials
  instagram: (() => <Instagram />)(),
  twitter: (() => <Twitter />)(),
  youtube: (() => <Youtube />)(),
  pinterest: (() => <PinterestP />)(),
  facebook: (() => <FacebookF />)(),
  questionCircle: (() => <QuestionCircle />)(),
  blog: (() => <Image alt="blog" src={blog} width={52} />)(),
  strava: (() => <Strava />)(),
  tiktok: (() => <TikTok />)(),

  // Flags
  adFlag: (() => <ADFlag />)(),
  aeFlag: (() => <AEFlag />)(),
  alFlag: (() => <ALFlag />)(),
  atFlag: (() => <ATFlag />)(),
  auFlag: (() => <AUFlag />)(),
  baFlag: (() => <BAFlag />)(),
  beFlag: (() => <BEFlag />)(),
  bgFlag: (() => <BGFlag />)(),
  brFlag: (() => <BRFlag />)(),
  caFlag: (() => <CAFlag />)(),
  chFlag: (() => <CHFlag />)(),
  clFlag: (() => <CLFlag />)(),
  cnFlag: (() => <CNFlag />)(),
  coFlag: (() => <COFlag />)(),
  cyFlag: (() => <CYFlag />)(),
  czFlag: (() => <CZFlag />)(),
  deFlag: (() => <DEFlag />)(),
  dkFlag: (() => <DKFlag />)(),
  dzFlag: (() => <DZFlag />)(),
  eeFlag: (() => <EEFlag />)(),
  esFlag: (() => <ESFlag />)(),
  fiFlag: (() => <FIFlag />)(),
  frFlag: (() => <FRFlag />)(),
  gbFlag: (() => <GBFlag />)(),
  grFlag: (() => <GRFlag />)(),
  hkFlag: (() => <HKFlag />)(),
  hrFlag: (() => <HRFlag />)(),
  huFlag: (() => <HUFlag />)(),
  idFlag: (() => <IDFlag />)(),
  ieFlag: (() => <IEFlag />)(),
  ilFlag: (() => <ILFlag />)(),
  isFlag: (() => <ISFlag />)(),
  itFlag: (() => <ITFlag />)(),
  jeFlag: (() => <JEFlag />)(),
  jpFlag: (() => <JPFlag />)(),
  krFlag: (() => <KRFlag />)(),
  kzFlag: (() => <KZFlag />)(),
  ltFlag: (() => <LTFlag />)(),
  luFlag: (() => <LUFlag />)(),
  lvFlag: (() => <LVFlag />)(),
  maFlag: (() => <MAFlag />)(),
  mcFlag: (() => <MCFlag />)(),
  mdFlag: (() => <MDFlag />)(),
  meFlag: (() => <MEFlag />)(),
  mkFlag: (() => <MKFlag />)(),
  mtFlag: (() => <MTFlag />)(),
  nlFlag: (() => <NLFlag />)(),
  noFlag: (() => <NOFlag />)(),
  nzFlag: (() => <NZFlag />)(),
  phFlag: (() => <PHFlag />)(),
  plFlag: (() => <PLFlag />)(),
  ptFlag: (() => <PTFlag />)(),
  reFlag: (() => <REFlag />)(),
  roFlag: (() => <ROFlag />)(),
  rsFlag: (() => <RSFlag />)(),
  ruFlag: (() => <RUFlag />)(),
  seFlag: (() => <SEFlag />)(),
  sgFlag: (() => <SGFlag />)(),
  siFlag: (() => <SIFlag />)(),
  skFlag: (() => <SKFlag />)(),
  tnFlag: (() => <TNFlag />)(),
  trFlag: (() => <TRFlag />)(),
  twFlag: (() => <TWFlag />)(),
  uaFlag: (() => <UAFlag />)(),
  usFlag: (() => <USFlag />)(),
  zaFlag: (() => <ZAFlag />)(),

  // Business
  barChart: (() => <BarChart />)(),
  briefcase: (() => <Briefcase />)(),
  chatboxEllipses: (() => <ChatboxEllipses />)(),
  megaphone: (() => <Megaphone />)(),
  paper: (() => <Paper />)(),
  reload: (() => <Reload />)(),
  terminal: (() => <Terminal />)(),
  storefront: (() => <Storefront />)(),
  storefrontLight: (() => <StorefrontLight />)(),
  fileTray: (() => <FileTray />)(),
  boundingBox: (() => <BoundingBox />)(),
  box: (() => <Box />)(),
  circleStar: (() => <CircleStar />)(),
  comments: (() => <Comments />)(),
  locationDot: (() => <LocationDot />)(),
  truckLight: (() => <TruckLight />)(),
  helpChatLight: (() => <HelpChatLight />)(),

  // Deckers Logo
  deckersWhite: (() => (
    <Image alt="deckers" src={deckersWhite} width={150} />
  ))(),
  deckersBlack: (() => <Image alt="deckers" src={deckersBlack} width={150} />)()
};
